import { jsx } from "react/jsx-runtime";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { DSInputText } from "@elliemae/ds-form-input-text";
import { Grid } from "@elliemae/ds-grid";
import { useTextboxFieldUpdateLogic } from "./utils/fieldUpdateLogic";
const PERCENT_VALUES = {
  allowNegative: true,
  decimalPlaces: 3,
  suffix: "%",
  includeThousandsSeparator: false
};
const NOT_DECIMAL_PLACES = {
  allowNegative: true,
  decimalPlaces: 0,
  prefix: "$"
};
const Textbox = ({
  renderedField,
  schemaForm,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  ui,
  disabled
}) => {
  const textboxUpdateLogic = useTextboxFieldUpdateLogic();
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      name,
      label,
      required,
      feedbackMessage,
      children: /* @__PURE__ */ jsx(
        DSInputText,
        {
          ...renderedField,
          "data-testid": "textbox",
          value: renderedField?.value ?? "",
          onChange: textboxUpdateLogic(renderedField, schemaForm),
          disabled,
          id: pathValue
        }
      )
    }
  ) });
};
export {
  Textbox
};
